"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchByNPI = void 0;
const parseNPIResponse = (responseText) => {
    try {
        const response = JSON.parse(responseText);
        const [resultCount, , , resultsArray] = response;
        if (!Array.isArray(resultsArray)) {
            throw new Error("Invalid results array in NPI response");
        }
        const results = resultsArray.map(item => {
            if (!Array.isArray(item) || item.length < 4) {
                throw new Error("Invalid result item format in NPI response");
            }
            const [fullName, , providerType, addressPractice] = item;
            return {
                fullName: String(fullName),
                providerType: String(providerType),
                addressPractice: String(addressPractice),
            };
        });
        return {
            resultCount,
            results,
        };
    }
    catch (error) {
        throw new Error(`Failed to parse NPI response: ${error instanceof Error ? error.message : "Unknown error"}`);
    }
};
const searchByNPI = (npiNumber) => __awaiter(void 0, void 0, void 0, function* () {
    const targetUrl = `https://clinicaltables.nlm.nih.gov/api/npi_idv/v3/search?terms=${npiNumber}`;
    const response = yield fetch(targetUrl);
    if (response.ok) {
        const responseData = yield response.text();
        return parseNPIResponse(responseData);
    }
    throw new Error(`Error searching NPI: ${npiNumber}, ${response.status}, ${response.statusText}`);
});
exports.searchByNPI = searchByNPI;
